import { gql } from '@apollo/client';

export const MEMBER_CHECK_BY_BIG_N = gql`
  query memberCheckForBigN($input: MemberBigNInput) {
    memberCheckForBigN(bigN: $input) {
      firstName
      lastName
      code
      explanation
      sector
      status
      tierName
      tags
      product
      sponsorId
      isDependent
      tierGroupId
    }
  }
`;

const useMemberCodeV2 = gql`
  query memberCheckForCodeV2($code: String) {
    memberCheckForCodeV2(code: $code) {
      firstName
      lastName
      code
      explanation
      sector
      status
      tierName
      tags
      memberStartDate
      memberEndDate
      product
      sponsorId
      isDependent
      tierGroupId
    }
  }
`;

const useCheckMemberAccessToGym = gql`
  query checkMemberAccessToGym(
    $facilityId: String
    $serviceSector: String
    $memberTags: [String]
    $product: String
    $sponsorId: String
    $isDependent: Boolean
  ) {
    checkMemberAccessToGym(
      facilityId: $facilityId
      serviceSector: $serviceSector
      memberTags: $memberTags
      product: $product
      sponsorId: $sponsorId
      isDependent: $isDependent
    )
  }
`;

// Userd for: obsolete?
const useMemberCode = gql`
  query memberCheckForCode($code: String) {
    memberCheckForCode(code: $code) {
      firstName
      lastName
      code
      explanation
      sector
      status
      tierName
      tags
    }
  }
`;
export const MEMBER_CHECK_BY_CODE = useMemberCodeV2;
export const CHECK_MEMBER_ACCESS_TO_GYM = useCheckMemberAccessToGym;
